import { render, staticRenderFns } from "./Case.vue?vue&type=template&id=0149924e&scoped=true&"
import script from "./Case.vue?vue&type=script&lang=js&"
export * from "./Case.vue?vue&type=script&lang=js&"
import style0 from "./Case.vue?vue&type=style&index=0&id=0149924e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0149924e",
  null
  
)

export default component.exports